<div class="container">
  <ng-container *ngIf="this.data.file.fileDetails.length > 0">
    <ngx-slick-carousel
      *ngIf="isImage(this.data.file.fileDetails[0].fullPath)"
      class="carousel"
      #slickModal="slick-carousel"
      [config]="slideConfig"
    >
      <div ngxSlickItem *ngFor="let slide of images" class="slide mt-2">
        <div class="container image-container">
          <div class="d-flex justify-content-center">
            <img src="{{ slide }}" alt="" width="auto" height="650px" />
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
    <div *ngIf="!isImage(this.data.file.fileDetails[0].fullPath)">
      <ngx-extended-pdf-viewer
        [src]="this.data.file.fileDetails[0].fullPath"
        [useBrowserLocale]="true"
      ></ngx-extended-pdf-viewer>
    </div>
  </ng-container>

  <div class="my-3">
    <div class="d-flex align-items-center mb-3">
      <p class="fw-bold">
        {{
          data.file.resultTypeValue == 1
            ? "Stool Lab Results"
            : data.file.resultTypeValue == 2
            ? "X-ray Lab Results"
            : "Syphilis Lab Results"
        }}
      </p>
      <p
        *ngIf="
          data.file.resultTypeValue == 2 &&
          this.data.application.applicationXRayDiagnoses.length !== 0
        "
        class="ms-2"
      >
        ({{
          this.data.application.applicationXRayDiagnoses?.at(-1)
            .xRayDiagnosisName
        }})
      </p>
    </div>
    <!-- <mat-form-field appearance="outline" *ngIf="data.file.resultTypeValue == 2">
      <mat-label>Type</mat-label>
      <mat-select [formControl]="selectedXrayType">
        <mat-option [value]="item.id" *ngFor="let item of xrayConditions">{{
          item.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="data.file.resultTypeValue == 2">
      <mat-label>Diagnosis</mat-label>
      <mat-select [formControl]="xrayDiagnosis">
        <mat-option [value]="item.id" *ngFor="let item of xraySubConditions">{{
          item.name
        }}</mat-option>
      </mat-select>
    </mat-form-field> -->
    <mat-form-field appearance="outline">
      <mat-label>Review</mat-label>
      <mat-select [formControl]="reviewControl">
        <mat-option value="1">Compliant</mat-option>
        <mat-option value="2">For Compliance</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Remarks</mat-label>
      <textarea [formControl]="remarksControl" matInput rows="6"></textarea>
    </mat-form-field>
  </div>
  <div class="d-flex flex-row-reverse">
    <button
      mat-raised-button
      color="primary"
      (click)="onReview()"
      style="color: white"
      [disabled]="isLoading"
    >
      {{ isLoading ? "Submitting" : "Submit" }}
    </button>
  </div>
</div>
